import { useEffect, useState } from "react";
import styled, { keyframes } from "styled-components";
import { SP_BREAKPOINT } from "../../../constants/app";
import { SidebarMenu } from "../../../ducks/app";
import { Button } from "../../atoms/Button";
import { SidebarFooter } from "../../molecules/sidebar/SidebarFooter";
import { SidebarHeaderSP } from "../../molecules/sidebar/SidebarHeaderSP";
import { SidebarMenus } from "../../molecules/sidebar/SidebarMenus";

type Props = {
  clientName: string;
  username: string;
  sidebarMenusToShow: SidebarMenu[];
  selectedMenuPath: string;
  onSidebarMenuClick: (path: string) => void;
  showSidebarSP: boolean;
  onSidebarSPClick: () => void;
  handleLogout: () => void;
};

export const SidebarSP: React.FC<Props> = ({
  clientName,
  username,
  sidebarMenusToShow,
  selectedMenuPath,
  onSidebarMenuClick,
  showSidebarSP,
  onSidebarSPClick,
  handleLogout,
}) => {
  const [isShown, setIsShown] = useState<boolean>(false);

  useEffect(() => {
    if (showSidebarSP) setIsShown(showSidebarSP);
    else setTimeout(() => setIsShown(showSidebarSP), 500);
  }, [showSidebarSP]);

  return (
    <StyledSideBarContainer>
      <SidebarHeaderSP isMenuOpen={showSidebarSP} onClick={onSidebarSPClick} />

      {isShown && (
        <StyledSidebarBackground $isOpen={showSidebarSP}>
          <StyledSidebarContainer $isOpen={showSidebarSP}>
            <SidebarHeaderSP
              hideLogo
              isMenuOpen={showSidebarSP}
              onClick={onSidebarSPClick}
            />

            <StyledSidebarContent>
              <StyledMenusContainer>
                <SidebarMenus
                  sidebarMenusToShow={sidebarMenusToShow}
                  selectedMenuPath={selectedMenuPath}
                  onSidebarMenuClick={onSidebarMenuClick}
                />
              </StyledMenusContainer>

              <StyledFooterContainer>
                <SidebarFooter
                  clientName={clientName}
                  username={username}
                  handleLogout={() => {}}
                />

                <Button
                  text="ログアウト"
                  variant="dark"
                  onClick={handleLogout}
                />
              </StyledFooterContainer>
            </StyledSidebarContent>
          </StyledSidebarContainer>
        </StyledSidebarBackground>
      )}
    </StyledSideBarContainer>
  );
};

const StyledSideBarContainer = styled.div`
  @media (max-width: ${SP_BREAKPOINT}) {
    width: 100vw;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    background-color: #ffffff;
  }

  display: none;
`;

const fadeIn = ($isOpen: boolean) => keyframes`
  from {
    opacity: 0;
    right: ${$isOpen ? "-325px" : "0"};
  }
  to {
    opacity: 1;
    right: ${$isOpen ? "0" : "-325px"};
  }
`;

const StyledSidebarBackground = styled.div<{ $isOpen: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 9997;
  opacity: ${({ $isOpen }) => ($isOpen ? 1 : 0)};
  transition: all 0.5s ease;
`;

const StyledSidebarContainer = styled.div<{ $isOpen: boolean }>`
  @media (max-width: ${SP_BREAKPOINT}) {
  }

  position: absolute;
  top: 0%;
  right: ${({ $isOpen }) => ($isOpen ? "0" : "-325px")};
  display: flex;
  width: 325px;
  height: 100%;
  flex-direction: column;
  align-items: flex-end;
  flex-shrink: 0;
  ${({ $isOpen }) => ($isOpen ? "" : "display: none;")}
  background-color: white;
  opacity: ${({ $isOpen }) => ($isOpen ? 1 : 0)};
  box-shadow: 4px 6px 10px 0px rgba(0, 0, 0, 0.1);
  animation: ${({ $isOpen }) => fadeIn($isOpen)} 0.5s forwards;
`;

const StyledSidebarContent = styled.div`
  display: flex;
  padding: 0px 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
`;

const StyledMenusContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0;
  gap: 10px;
  overflow-y: auto;
  overflow-x: hidden;
`;

const StyledFooterContainer = styled.div`
  display: flex;
  padding-left: 0;
  align-items: center;
  gap: 24px;
  align-self: stretch;

  button {
    padding: 14px 0px;
  }
`;
